export default function (ctrl, $interval) {
	return $interval(function () {

		--ctrl.countDownSeconds;

		if (ctrl.countDownSeconds <= 0) {
			$interval.cancel(ctrl.countdown);
		}
	}, 1000);
};
